import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a30.81 30.81 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a34.717 34.717 0 0 1-.337 5.316H.325a34.916 34.916 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316ZM8.667 10a8.001 8.001 0 0 1 14.549 0H8.666Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M24.446 10c.566-.546.946-.855 1.142-.926.346-.126.86-.173 1.042.33a.578.578 0 0 1-.089.596h-2.095ZM5.458 10a.578.578 0 0 1-.089-.596c.184-.503.697-.456 1.043-.33.195.071.576.38 1.141.926H5.458ZM16 4.667c-.445-.955-.667-1.555-.667-1.8 0-.368.131-.867.667-.867.535 0 .666.499.666.867 0 .245-.222.845-.666 1.8Zm1.736.175c-.237-1.026-.33-1.659-.278-1.899.076-.36.308-.82.832-.71.524.112.549.627.472.987-.051.24-.393.781-1.026 1.622Zm1.686.53c-.036-1.053-.006-1.692.09-1.918.144-.34.46-.747.952-.538.493.21.42.72.275 1.059-.096.226-.535.691-1.317 1.396Zm1.526.846c.183-1.037.345-1.656.486-1.857.211-.302.605-.635 1.043-.327.439.307.26.79.05 1.092-.142.2-.668.565-1.58 1.092Zm1.34 1.152c.378-.983.656-1.56.832-1.73.265-.256.715-.508 1.087-.123.372.386.104.826-.16 1.082-.177.17-.763.428-1.758.77Zm1.067 1.38c.575-.882.965-1.389 1.174-1.519.312-.195.804-.348 1.088.106.284.454-.07.83-.382 1.025-.208.13-.834.26-1.88.388Zm-14.71 0c-1.046-.129-1.672-.258-1.88-.388-.313-.195-.666-.57-.382-1.025.283-.454.776-.301 1.088-.106.208.13.6.637 1.173 1.52ZM9.71 7.37c-.995-.343-1.581-.6-1.758-.77-.265-.257-.532-.697-.16-1.083.372-.385.821-.133 1.086.123.177.17.454.747.832 1.73Zm1.34-1.152c-.91-.527-1.437-.891-1.578-1.092-.21-.302-.39-.785.05-1.093.438-.307.831.026 1.043.328.14.201.302.82.486 1.857Zm1.526-.847c-.782-.705-1.22-1.17-1.317-1.396-.144-.34-.218-.85.275-1.059.493-.209.809.199.953.538.096.226.125.865.09 1.917Zm1.687-.529c-.633-.841-.975-1.382-1.026-1.622-.077-.36-.052-.875.472-.986.523-.111.755.349.832.709.05.24-.042.873-.278 1.9Z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagMwi = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMwi_default = SvgFlagMwi;

export { FlagMwi_default as default };
